var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrapper"},[_c('v-btn',{staticClass:"login-button",on:{"click":function($event){return _vm.goToOktaLogin()}}},[_vm._v(" Login with Okta ")]),(_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }